import React from 'react';
import '../../assets/css/footerstyle.css';
import {Link} from 'react-router-dom';
import Expo from '../Common/Expo';

const Footer = () => {

return(
   <>
      <footer id="footer" className=" bg-gray-900 text-white footer">
    <div className="container" style={{ maxWidth:"1192px"}}>
    
      <div className="flex flex-wrap">
        <div className="w-full lg:w-1/3 mb-0 borderight">
          <h4 className="text-sm font-normal mb-2 color-gray-300"> INFORMATION </h4>
          <ul className="text-sm space-y-1 pl-0">
            <li><Link to="/about" className="capitalize color-gray-400 text-decoration-none"> <i className="bi bi-chevron-right i-icon"></i> About Us</Link></li>
            <li><Link to="/privacy" className="capitalize color-gray-400 text-decoration-none"><i className="bi bi-chevron-right i-icon"></i> Loyalty Points Terms & Conditions</Link></li>
            <li><Link to="/loyalty" className="capitalize color-gray-400 text-decoration-none"><i className="bi bi-chevron-right i-icon"></i> Privacy Policy</Link></li>
          </ul>
        </div>
        <div className="w-full lg:w-1/3 mb-0 borderight paddingLeftSide">
          <h4 className="text-sm font-normal mb-2 color-gray-300 "> OFFICE ADDRESS  </h4>
          <ul className="text-sm space-y-1 pl-0">
            <li className="color-gray-400">
              <div style={{display:"flex", gap:"8px"}}> 
              <i className="bi bi-crosshair iii-icon"></i> 
              <span> 20, Pusa Road, <br />
              New Delhi, Central Delhi, <br />
              Delhi 110005 India
              </span>
              </div>
            </li>
            <li className='color-gray-400' style={{ marginTop:"9px"}}> <i className="bi bi-card-list iii-icon"></i>&nbsp; <strong className='iii-icon'>CIN :</strong> U74994DL2004PTC124979</li>
          </ul>
        </div>
        <div className="w-full lg:w-1/3 mb-0 paddingLeftSide">
                   
       <div style={{display:"flex", flexDirection:"column"}}> 
        <div className="w-full">
          <div className="mt-0">
            <div className="text-sm flex items-center gap-2 color-gray-300">
              <img src="https://b2b.obsessions.co.in/public/design/img/icon/phone.png" className="w-[30px] -mt-3 goldencolor" alt="Phone"  style={{ marginTop: "6px" }} />
              1800-3000-3200
            </div>
          </div>
        </div>


        <div className="w-full">
          <div className="mt-1 text-sm flex items-center gap-2">
            <img src="https://b2b.obsessions.co.in/public/design/img/icon/email.png" className="w-[30px] -mt-1 goldencolor" alt="Email " style={{ marginTop: "6px" }} />
            <a href="mailto:contact@obsessions.co.in" className="text-gray-300 color-gray-300 text-decoration-none">contact@obsessions.co.in</a>
          </div>
        </div>


        <div className="w-full flex items-left" style={{ flexDirection:"column", marginTop:"13px"}}>
          <span className="text-sm mr-2 color-gray-300 iii-icon" style={{ fontWeight:"500", marginBottom:"5px"}}>Follow Us &nbsp; <i className="bi bi-dash iii-icon"></i> </span>
          <div className="flex gap-1">
                  {[
                    ["facebook", "https://www.facebook.com/obsessionsindia"],
                    ["instagram", "https://www.instagram.com/obsessionsindia/"],
                    ["youtube", "https://www.youtube.com/channel/UCyuqgAQbjFLBIcjPoSmylDQ"],
                    ["linkedin", "https://in.linkedin.com/in/obsessions-india-520090174"]
                  ].map(([platform, url]) => (
                    <a
                      key={platform}
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-[30px]"
                    >
                      <img
                        src={`https://b2b.obsessions.co.in/public/design/img/icon/${platform}.png`}
                        className="w-[30px] mt-1 goldencolor"
                        alt={platform}
                      />
                    </a>
                  ))}
                </div>
             </div>
          </div>
        </div>
      </div>
  
      <hr className="border-gray-700 my-2" />
      <p className="text-center text-gray-400 text-xs m-0 pb-2">
        © 2026 En’Vogue Furnishings India Pvt. Ltd. | All Rights Reserved.
      </p>
     
    </div>
     </footer>

      <Expo/>


   </>
  
  )
 }
 export default Footer;